import { getQuotationById, getQuotationList, saveBudgetInfo, updateBudgetInfo, getSpreadsheetInfo } from './../../Api/spreadsheetApi';
import { getFirstAccess } from 'Api/spreadsheetApi';
import { SpreadsheetState } from 'Types/_Store/spreadsheet'
import { SpreadsheetStep } from 'Enums/spreadsheetSteps'
import cloneDeep from 'lodash/cloneDeep'
import { parseBudgetInfo } from 'Parsers/companyInfoParser';

const state: SpreadsheetState = {
  requesting: {
    requestList: false,
    infoCompany: false,
    firstAccess: false,
    saveBudget: false,
    infoSubmit: false,
    spreadsheetInfo: false,
  },

  stepList: [
    {
      id: SpreadsheetStep.welcome,
      name: 'welcome',
    },
    {
      id: SpreadsheetStep.quotations,
      name: 'quotations',
    },
    {
      id: SpreadsheetStep.companyInfo,
      name: 'companyInfo',
    },
    {
      id: SpreadsheetStep.download,
      name: 'download',
    }
  ],

  currentStep: {
    id: SpreadsheetStep.welcome,
    name: 'welcome',
  },

  requestList: [],

  isEditing: false,

  currentCompanyId: null,

  companyQuotationInfo: {
    alreadyReceivedBudget: true,
    amount: 0,
    company: {
      ddd: '',
      email: '',
      logoMediumUrl: '',
      name: '',
      phone: '',
      userName: ''
    },
    deadline: '',
    description: '',
    paymentMethods: ''
  },

  errorList: [],
  errorMessage: '',
  spreadsheetInfo: null

}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_current_step(state, step) {
    state.currentStep = state.stepList[step]
  },

  set_request_list(state, list) {
    state.requestList = list
  },

  set_current_company_id(state, id) {
    state.currentCompanyId = id
  },

  set_company_quotation_info(state, info) {
    state.companyQuotationInfo = info
  },

  set_info(state, info) {
    state.companyQuotationInfo = info
  },

  set_quotation_validation(state, { errorList, isDirty, errorMessage }) {
    state.errorList = errorList
    state.errorMessage = errorMessage
  },

  set_budget(state, budget) {
    state.companyQuotationInfo.amount = budget
  },

  set_editing(state, flag) {
    state.isEditing = flag
  },

  set_spreadsheet_info(state, data) {
    state.spreadsheetInfo = data
  }
}

const actions = {
  async getFirstAccess({ commit }){
    commit('request_start', 'firstFirstAccess')

    try {
      const { data } = await getFirstAccess()
      if(!data){
        commit('set_current_step', SpreadsheetStep.quotations)
      }else{
        commit('set_current_step', SpreadsheetStep.welcome)
      }

      commit('request_success', 'firstFirstAccess')

      return data
    } catch (error) {
      commit('request_failure', 'firstFirstAccess')
      throw error
    }
  },

  async updateCurrentStep ({ commit }, step){
    try {
      commit('set_current_step', step)

    } catch (error) {
      throw error
    }
  },

  async getRequestList({ commit }, id){
    commit('request_start', 'requestList')

    try {
      const { data } = await getQuotationList(id)
      // const { parsedData} = await parserCompanyInfo(data)

      commit('request_success', 'requestList')

      commit('set_request_list', data);
      return data
    } catch (error) {
      commit('request_failure', 'requestList')
      throw error
    }
  },

  async updateCurrentCompanyId({ commit }, id) {
    try {
      commit('set_current_company_id', id);
    } catch (error) {
      throw error
    }
  },

  async getQuotationCompany({ commit }, id) {
    commit('request_start', 'infoCompany')

    try {
      const { data } = await getQuotationById(id)

      commit('request_success', data)

      commit('set_company_quotation_info', data)

      return data
    } catch (error) {
      commit('request_failure', 'infoCompany')

      throw error
    }
  },


  updateValidation({ commit, state }, options) {
    const isDefined = (value) => typeof value !== 'undefined'

    const errorList = isDefined(options.errorList)
      ? options.errorList
      : state.errorList


    const errorMessage = isDefined(options.errorMessage)
      ? options.errorMessage
      : state.errorMessage

    const validation = {
      errorList,
      errorMessage,
    }

    commit('set_quotation_validation', validation)
  },

  updateInfo({ commit, state }, info) {
    commit('set_info', Object.assign(
      cloneDeep(state.companyQuotationInfo),
      info
    ))
  },

  updateBudget({ commit }, budget: number) {
    commit('set_budget', budget)
  },

  async submitInfo({ commit, dispatch, state }, info) {
    commit('request_start', 'infoSubmit')
    try {

      const parsedInfo = parseBudgetInfo(info, state.currentCompanyId)
      const result =  await saveBudgetInfo(parsedInfo)

      commit('request_success', 'infoSubmit')

      dispatch('updateCurrentStep', SpreadsheetStep.quotations)

      return result
    } catch (err) {
      commit('request_failure', 'infoSubmit')

      throw err
    }
  },

  async updateBudgetInfo({ commit, dispatch, state }, info) {
    commit('request_start', 'infoSubmit')
    try {

      const parsedInfo = parseBudgetInfo(info, state.currentCompanyId)
      const result =  await updateBudgetInfo(parsedInfo)

      commit('request_success', 'infoSubmit')

      dispatch('updateCurrentStep', SpreadsheetStep.quotations)

      return result
    } catch (err) {
      commit('request_failure', 'infoSubmit')

      throw err
    }
  },

  async updateIsEdintting({ commit }, flag){
    commit('set_editing', flag)
  },

  async getSpreadsheetInfo({ commit }, quotationId){
    commit('request_start', 'spreadsheetInfo')
    try {

      const { data } = await getSpreadsheetInfo(quotationId)

      commit('set_spreadsheet_info', data)

      commit('request_success', 'spreadsheetInfo')


      return data
    } catch (err) {
      commit('request_failure', 'spreadsheetInfo')

      throw err
    }
  }

}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}